export default __webpack_public_path__ + "static/media/avatar_dragon1.8713a3d6.mp3";